import { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { useAuth } from './AuthContext';
import toast from 'react-hot-toast';

const SocketContext = createContext();

export const SocketProvider = ({ children }) => {
  const { user, setUnreadCount } = useAuth();
  const [socket, setSocket] = useState(null);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    if (!user) {
      if (socket) { socket.disconnect(); setSocket(null); }
      return;
    }

    const newSocket = io(process.env.REACT_APP_API_URL || 'http://localhost:5000', {
      query: { userId: user._id },
      transports: ['websocket', 'polling'],
    });

    newSocket.on('connect', () => {
      setIsConnected(true);
      console.log('Socket connected ✅');
    });

    newSocket.on('disconnect', () => setIsConnected(false));

    // Real-time notification
    newSocket.on('new_notification', (notif) => {
      setUnreadCount(prev => prev + 1);
      toast(notif.title || 'Nayi notification!', {
        icon: '🔔',
        duration: 4000,
        style: {
          background: '#1e293b',
          color: 'white',
          fontSize: '14px',
        }
      });
    });

    setSocket(newSocket);

    return () => { newSocket.disconnect(); };
  }, [user?._id]);

  return (
    <SocketContext.Provider value={{ socket, isConnected }}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);